import * as React from 'react';
export var useInputBase = _ref => {
  var {
    onBlur: onBlurParent,
    onChange: onChangeParent,
    onFocus: onFocusParent,
    onBackspace,
    autoSelect,
    initialValue,
    changeFocus,
    onSubmit,
    onPaste: onPastParent
  } = _ref;

  var validate = value => {
    var numCode = value.charCodeAt(0);
    var isInteger = numCode >= '0'.charCodeAt(0) && numCode <= '9'.charCodeAt(0);
    return isInteger ? value : '';
  };

  var [value, setValue] = React.useState(validate(initialValue));
  var [isFocused, setIsFocused] = React.useState(false);
  var input = React.useRef(null);

  var onFocus = event => {
    if (autoSelect) {
      event.currentTarget.select();
    }

    setIsFocused(true);
    onFocusParent === null || onFocusParent === void 0 ? void 0 : onFocusParent(event);
  };

  var onBlur = event => {
    setIsFocused(false);
    onBlurParent === null || onBlurParent === void 0 ? void 0 : onBlurParent(event);
  };

  var onKeyDown = e => {
    switch (e.key) {
      case 'Backspace':
        if (!value || !value.length) onBackspace();
        break;

      case 'ArrowLeft':
        e.preventDefault();
        changeFocus('left');
        break;

      case 'ArrowRight':
        e.preventDefault();
        changeFocus('right');
        break;

      case 'Enter':
        onSubmit();
        break;

      default:
        break;
    }
  };

  var update = function update(newValue) {
    var isPasting = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var value = validate(newValue);

    if (value.length < 2) {
      setValue(value);
      setTimeout(() => {
        onChangeParent(value, isPasting);
      }, 0);
    }
  };

  var onChange = e => {
    update(e.currentTarget.value);
  };

  var onPaste = e => {
    if (!onPastParent) {
      return;
    }

    var value = e.clipboardData.getData('text');
    onPastParent(value);
  };

  var focus = () => {
    var _input$current;

    (_input$current = input.current) === null || _input$current === void 0 ? void 0 : _input$current.focus();
  };

  return {
    input,
    value,
    onKeyDown,
    onPaste,
    onChange,
    onFocus,
    onBlur,
    isFocused,
    focus,
    update
  };
};
//# sourceMappingURL=useInputBase.js.map